import * as React from "react";
import { HTMLAttributes } from "react";
import { cn } from "@repo/utils/cn";

export type ButtonGroupProps = {
  reverse?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export function ButtonGroup({
  className,
  children,
  reverse,
  ...props
}: ButtonGroupProps) {
  return (
    <div
      {...props}
      className={cn(
        "ui:inline-flex ui:items-center ui:gap-2",
        {
          "ui:flex-row-reverse": reverse,
        },
        className,
      )}
    >
      {children}
    </div>
  );
}
